<template>
    <div>
        <div class="mb-3">
            <hr />
            <h5>{{ $t("wizard.form.title.data-profiling") }}</h5>
            <p>{{ $t("wizard.form.title.complate-the") }}</p>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-body">
                    <form>
                        <div class="form-group row mb-4">
                        <label
                            for="profile_target"
                            class="col-form-label col-lg-2"
                            >{{
                            $t("wizard.form.label.profile-target")
                            }}</label
                        >
                        <div class="col-lg-10">
                            <input
                            id="profile_target"
                            name="profile_target"
                            v-model="titleTarget"
                            type="text"
                            class="form-control"
                            :placeholder="
                                $t('wizard.form.label.profile-target')
                            "
                            />
                        </div>
                        </div>
                        <div class="form-group row mb-4">
                        <label
                            for="instagram"
                            class="col-form-label col-lg-2"
                            >Instagram</label
                        >
                        <div class="col-lg-10">
                            <input
                            readonly
                            id="instagram"
                            type="text"
                            class="form-control bg-light"
                            v-model="form.sosmed.instagram"
                            />
                        </div>
                        </div>
                        <div class="form-group row mb-4">
                        <label for="twiter" class="col-form-label col-lg-2"
                            >Twitter</label
                        >
                        <div class="col-lg-10">
                            <input
                            readonly
                            id="twiter"
                            type="text"
                            class="form-control bg-light"
                            v-model="form.sosmed.twitter"
                            />
                        </div>
                        </div>
                        <div class="form-group row mb-4">
                        <label
                            for="facebook"
                            class="col-form-label col-lg-2"
                            >Facebook</label
                        >
                        <div class="col-lg-10">
                            <input
                            readonly
                            id="facebook"
                            type="text"
                            class="form-control bg-light"
                            v-model="form.sosmed.facebook"
                            />
                        </div>
                        </div>
                        <div class="form-group row mb-4">
                        <label
                            for="facebook"
                            class="col-form-label col-lg-2"
                            >TikTok</label
                        >
                        <div class="col-lg-10">
                            <input
                            readonly
                            id="tiktok"
                            type="text"
                            class="form-control bg-light"
                            v-model="form.sosmed.tiktok"
                            />
                        </div>
                        </div>
                        <div class="form-group row mb-4">
                        <label
                            for="telegram"
                            class="col-form-label col-lg-2"
                            >Telegram</label
                        >
                        <div class="col-lg-10">
                            <input
                            readonly
                            id="telegram"
                            type="text"
                            class="form-control bg-light"
                            v-model="form.sosmed.telegram"
                            />
                        </div>
                        </div>
                        <div class="form-group row mb-4">
                        <label
                            for="telegram"
                            class="col-form-label col-lg-2"
                            >Website</label
                        >
                        <div class="col-lg-10">
                            <b-input
                            id="telegram"
                            type="text"
                            class="form-control"
                            v-model="form.website"
                            />
                        </div>
                        </div>
                        <div class="form-group row mb-4">
                        <label
                            for="telephone"
                            class="col-form-label col-lg-2"
                            >Telephone</label
                        >
                        <div class="col-lg-8">
                            <input
                            id="telephone"
                            type="text"
                            class="form-control"
                            :class="validFormat"
                            rows="3"
                            placeholder="+xx xxxx-xxxx-xxx"
                            v-model="form.telephone"
                            v-mask="'+## ####-####-####-####'"
                            />
                            <div
                            :class="
                                validformat
                                ? 'valid-feedback'
                                : 'invalid-feedback'
                            "
                            >
                            <span>{{
                                validformat
                                ? "Phone Info Found"
                                : phoneinfo[0]
                            }}</span>
                            </div>
                        </div>
                        <div class="col-lg-2 mt-lg-0 mt-md-2">
                            <b-button
                            block
                            class=""
                            variant="primary"
                            @click="getPhoneInfo()"
                            >
                            <div
                                v-show="
                                screen.width > 1250 || screen.width < 980
                                "
                            >
                                Phone Info
                                <i
                                class="
                                    fas
                                    fa-address-book
                                    font-size-16
                                    align-middle
                                    ml-1
                                "
                                ></i>
                            </div>
                            <div
                                v-show="
                                screen.width < 1250 && screen.width > 980
                                "
                            >
                                <i
                                class="
                                    fas
                                    fa-address-book
                                    font-size-16
                                    align-middle
                                    ml-1
                                "
                                ></i>
                            </div>
                            </b-button>
                        </div>
                        </div>
                        <div class="form-group row mb-4">
                        <label
                            for="category"
                            class="col-form-label col-lg-2"
                            >{{ $t("wizard.form.label.category") }}</label
                        >
                        <div class="col-lg-10">
                            <select
                            name=""
                            id=""
                            class="form-control"
                            v-model="idCategory"
                            >
                            <option
                                v-for="cat in category"
                                :key="cat.id_category"
                                :value="cat.id_category"
                            >
                                {{ cat.category_name }}
                            </option>
                            </select>
                        </div>
                        </div>
                    </form>
                    </div>
                </div>
            </div>
            <!-- end col -->
        </div>
    </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import Vue from "vue";
import { required } from "vuelidate/lib/validators";
import CategoryService from "@/helpers/category.service";
import UserService from "@/helpers/user.service";
import SherlockService from "@/helpers/sherlock.service";
import moment from "moment";
import TargetService from "@/helpers/target-profile.service";
import SocmedService from "@/helpers/socmed.service";
import TwintService from "@/helpers/twint.service";
import { gmapApi } from "vue2-google-maps";
import PhoneService from "@/helpers/phone.service";
import WebsiteService from "@/helpers/website.service.js";
import PreferenceService from "@/helpers/preference.service.js";
import Swal from "sweetalert2";


/**
 * Form wizard component
 */
export default {
    props: {
        "doValidation": Boolean,
        "idTarget": { type: String, default: "" },
        "idCategory": { type: String, default: "" },
        "titleTarget": { type: String, default: "" },
    },
  components: {
    FormWizard,
    TabContent,
  },
  watch: {
    doValidation: {
      immediate: true,
      handler(n) {
        if (n) {
          this.finishWizard();
        }
      },
    },
  },
  data() {
    return {
      form: {
        sosmed: {
          instagram: "",
          twitter: "",
          facebook: "",
          telegram: "",
          tiktok: "",
        },
        telephone: "",
        website: "",
      },
      screen: {
        width: 0,
        height: 0,
      },
      category: [],
      phoneinfo: [],
      validformat: null,
      searchResultWebinfo: "",
      searchResultWhois: "",
      searchResultIpLocation: "",
      searchResultService: "",
      searchResultCms: "",
      searchResultSubDomain: "",
      domainSearch: "",
      idWebInfo: "",
      idWhois: "",
      idIp: "",
      idWebService: "",
      idCms: "",
      idPrivateWeb: "",
      statusProcess: "",
    //   id_target: "",
    };
  },

  computed: {
    validFormat() {
      if (this.validformat != null) {
        if (this.validformat) {
          return "is-valid";
        } else {
          return "is-invalid";
        }
      }
    },
  },

  validations: {
    form: {
      search: {},
      instagram: {},
      twitter: {},
      facebook: {},
      telegram: {},
      url: {},
      telephone: {},
      website: {},
    },
  },

  methods: {
    //================================== wizard 4 ===================================//
    /* =======================================
         get website info
         =======================================
      */
    async savePrivateWeb() {
      var data = {
        id_target: this.idTarget,
        domain: this.domainSearch,
        id_ip: this.idIp,
        id_web_info: this.idWebInfo,
        id_whois: this.idWhois,
        id_web_service: this.idWebService,
        id_cms: this.idCms,
      };
      await WebsiteService.createPrivateWeb(data)
        .then((response) => {
          this.idPrivateWeb = response.data.data.id_private_web;
          this.messageProcess =
            "Almost done, completing website information gathering...";
          console.log("success save private web", response);
        })
        .catch((err) => {
          this.messageProcess =
            "!Something went wrong, failed completing website information gathering...";
          console.log("err save private web ", err);
        })
        .finally();
    },
    /** ======================================*/

    /* =======================================
         get website info
         =======================================
      */
    async getWebsiteInfo() {
      this.searchResultWebinfo = [];
      const query = {
        website: this.domainSearch,
      };
      await WebsiteService.searchWebInfo(query)
        .then((response) => {
          this.searchResultWebinfo = response.data.output;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally();

      var data = {
        domain_name: this.domainSearch,
        visitors: this.searchResultWebinfo.visitors,
        ip_address: this.searchResultWebinfo.ip_address,
        link_ipv6_address: this.searchResultWebinfo.link_ipv6_address,
        ip_location: this.searchResultWebinfo.ip_location,
        ip_reverse_dns: this.searchResultWebinfo.ip_reverse_dns,
        hosting_company: this.searchResultWebinfo.hosting_company,
        hosting_ip_range: this.searchResultWebinfo.hosting_ip_range,
        hosting_address: this.searchResultWebinfo.hosting_address,
        hosting_country: this.searchResultWebinfo.hosting_country,
        hosting_phone: this.searchResultWebinfo.hosting_phone,
        hosting_website: this.searchResultWebinfo.hosting_website,
        cidr: this.searchResultWebinfo.cidr,
        hosting_cidr: this.searchResultWebinfo.hosting_cidr,
      };
      await WebsiteService.createWebInfo(data)
        .then((response) => {
          this.idWebInfo = response.data.data.id_web_info;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally();

      var query2 = {
        website: this.domainSearch,
      };
      await WebsiteService.searchSubDomain(query2)
        .then((response) => {
          this.searchResultSubDomain = response.data.output;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally();

      var data2 = {
        id_web_info: this.idWebInfo,
        subdomain: JSON.stringify(this.searchResultSubDomain),
      };
      await WebsiteService.createSubDomain(data2)
        .then((response) => {})
        .catch((err) => {
          console.log(err);
        })
        .finally();
    },
    /** ======================================*/

    /* =======================================
         get whois lookup
         =======================================
      */
    async getWhois() {
      this.searchResultWhois = [];
      const query = {
        website: this.domainSearch,
      };
      await WebsiteService.searchDomainWhois(query)
        .then((response) => {
          this.searchResultWhois = response.data.output;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally();

      var data = {
        domain_name: this.searchResultWhois.domainName,
        created_date: this.searchResultWhois.createdDate,
        expired_date: this.searchResultWhois.expiresDate,
        contact_email: this.searchResultWhois.contact_email,
        registran_name: this.searchResultWhois.registrant_name,
        registran_organization: this.searchResultWhois.registrant_organization,
        registran_street: this.searchResultWhois.registrant_street,
        registran_city: this.searchResultWhois.registrant_city,
        registran_state: this.searchResultWhois.registrant_state,
        registran_postal_code: this.searchResultWhois.registrant_postalCode,
        registran_country: this.searchResultWhois.registrant_host_contry,
        registran_email: this.searchResultWhois.registrant_email,
        registran_phone: this.searchResultWhois.registrant_telephone,
        registran_fax: this.searchResultWhois.registrant_fax,
        admin_name: this.searchResultWhois.admin_name,
        admin_organization: this.searchResultWhois.admin_organization,
        admin_street: this.searchResultWhois.admin_street,
        admin_city: this.searchResultWhois.admin_city,
        admin_state_province: this.searchResultWhois.admin_city,
        admin_postal_code: this.searchResultWhois.admin_postalCode,
        admin_country: this.searchResultWhois.admin_countryCode,
        admin_email: this.searchResultWhois.admin_email,
        admin_phone: this.searchResultWhois.admin_telephone,
        admin_fax: this.searchResultWhois.admin_fax,
        tech_name: this.searchResultWhois.tech_name,
        tech_organization: this.searchResultWhois.tech_organization,
        tech_street: this.searchResultWhois.tech_street,
        tech_city: this.searchResultWhois.tech_city,
        tech_state_province: this.searchResultWhois.tech_state,
        tech_postal_code: this.searchResultWhois.tech_postalCode,
        tech_country: this.searchResultWhois.tech_host_contry,
        tech_email: this.searchResultWhois.tech_email,
        tech_phone: this.searchResultWhois.tech_telephone,
        tech_fax: this.searchResultWhois.tech_fax,
      };
      await WebsiteService.createWebWhois(data)
        .then((response) => {
          this.idWhois = response.data.data.id_whois;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally();
    },
    /** ======================================*/

    /* =======================================
         get ip location
         =======================================
      */
    async getIpLocation() {
      this.searchResultIpLocation = [];
      const query = {
        website: this.domainSearch,
      };
      await WebsiteService.searchDomainLocation(query)
        .then((response) => {
          this.searchResultIpLocation = response.data.output;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally();

      var data = {
        domain_name: this.domainSearch,
        ip_address: this.searchResultIpLocation.ip,
        version: this.searchResultIpLocation.version,
        city: this.searchResultIpLocation.city,
        region: this.searchResultIpLocation.region,
        region_code: this.searchResultIpLocation.region_code,
        country: this.searchResultIpLocation.country,
        country_name: this.searchResultIpLocation.country_name,
        country_code: this.searchResultIpLocation.country_code,
        country_code_iso3: this.searchResultIpLocation.country_code_iso3,
        country_capital: this.searchResultIpLocation.country_code_iso3,
        country_tld: this.searchResultIpLocation.country_tld,
        continent_code: this.searchResultIpLocation.continent_code,
        in_ue: this.searchResultIpLocation.in_eu,
        postal_code: this.searchResultIpLocation.postal,
        latitude: this.searchResultIpLocation.latitude,
        longitude: this.searchResultIpLocation.longitude,
        timezone: this.searchResultIpLocation.timezone,
        utc_offset: this.searchResultIpLocation.ip,
        country_calling_code: this.searchResultIpLocation.ip,
        currency: this.searchResultIpLocation.currency,
        currency_name: this.searchResultIpLocation.currency_name,
        languages: this.searchResultIpLocation.languages,
        country_area: this.searchResultIpLocation.country_area,
        country_population: this.searchResultIpLocation.country_population,
        asn: this.searchResultIpLocation.asn,
        org: this.searchResultIpLocation.org,
      };
      await WebsiteService.createWebInfoLocation(data)
        .then((response) => {
          this.idIp = response.data.data.id_ip;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally();
    },
    /** ======================================*/

    /* =======================================
         get service checker
         =======================================
      */
    async getServiceChecker() {
      this.searchResultService = [];
      const query = {
        website: this.domainSearch,
      };
      await WebsiteService.searchWebService(query)
        .then((response) => {
          this.searchResultService = response.data.output;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally();

      var data = {
        domain_name: this.domainSearch,
        ftp: this.searchResultService[0].status,
        ssh: this.searchResultService[1].status,
        telnet: this.searchResultService[2].status,
        smtp: this.searchResultService[3].status,
        whois: this.searchResultService[4].status,
        dns: this.searchResultService[5].status,
        dhcp: this.searchResultService[6].status,
        http: this.searchResultService[7].status,
        pop3: this.searchResultService[8].status,
        sftp: this.searchResultService[9].status,
        nntp: this.searchResultService[10].status,
        ntp: this.searchResultService[11].status,
        netbios: this.searchResultService[12].status,
        imap: this.searchResultService[13].status,
        snmp: this.searchResultService[14].status,
        imap3: this.searchResultService[15].status,
        ldap: this.searchResultService[16].status,
        ssl: this.searchResultService[17].status,
        oracle_sql: this.searchResultService[18].status,
        nfs: this.searchResultService[19].status,
        mysql: this.searchResultService[20].status,
        vnc: this.searchResultService[21].status,
        http2: this.searchResultService[22].status,
      };
      await WebsiteService.createWebService(data)
        .then((response) => {
          this.idWebService = response.data.data.id_web_service;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally();
    },
    /** ======================================*/

    /* =======================================
         get cms checker
         =======================================
      */
    async getCmsChecker() {
      this.searchResultCms = [];
      const query = {
        website: this.domainSearch,
      };
      await WebsiteService.searchWebCms(query)
        .then((response) => {
          this.searchResultCms = response.data.output;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally();

      var data = {
        domain_name: this.domainSearch,
        result: JSON.stringify(this.searchResultCms.result),
        social_media: JSON.stringify(this.searchResultCms.social_media),
      };
      await WebsiteService.createWebCmsChecker(data)
        .then((response) => {
          this.idCms = response.data.data.id_cms;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally();
    },
    /** ======================================*/

    /* =======================================
         get phone number information
         =======================================
      */
    getPhoneInfo() {
      const data = {
        number: this.form.telephone,
      };
      this.phoneinfo = [];
      this.loading = true;
      PhoneService.info(data)
        .then((response) => {
          this.phoneinfo.push(response.data.output);
          this.validformat = response.data.valid;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /** ======================================*/

    /* =======================================
         save private data information
         =======================================
      */
    savePrivateData() {
      if (this.phoneinfo != 0) {
        const data = {
          email: "",
          phone: this.form.telephone,
          phone_international_format: this.phoneinfo[0].international_format,
          phone_local_format: this.phoneinfo[0].local_format,
          phone_country_code: this.phoneinfo[0].country_code,
          phone_location: this.phoneinfo[0].location,
          phone_carrier: this.phoneinfo[0].carrier,
          phone_area: this.phoneinfo[0].area,
          phone_timezone: this.phoneinfo[0].timezone,
          phone_possibility: this.phoneinfo[0].possibility,
        };
        SocmedService.createPrivateData(data)
          .then((response) => {
            this.wizard_validation4.id_private_data =
              response.data.data.id_private_data;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    /** ======================================*/

    /* =======================================
         finishing wizard
         =======================================
      */
    async finishWizard() {
    //   this.disableFinish = true;
    //   this.loadingProcess = true;
    //   this.statusProcess = "process";
    //   this.messageProcess = "Please wait, Saving final information target...";
      await (this.domainSearch = this.normalizeUrl());
      await this.savePrivateData();
      if (this.domainSearch != "") {
        // await setTimeout(() => {
        //   this.messageProcess = "Please wait, Getting website information...";
        // }, 1000);
        await this.getWebsiteInfo();
        await this.getWhois();
        await this.getIpLocation();
        await this.getServiceChecker();
        await this.getCmsChecker();
        await this.savePrivateWeb();
      }

      let id_private_data = "";
      id_private_data = this.wizard_validation4.id_private_data;
      const formUpdate = new FormData();
      formUpdate.append("status_id", 2);
      formUpdate.append("id_category", this.idCategory);
      formUpdate.append("id_private_data", id_private_data);
      formUpdate.append(
        "id_private_web",
        this.domainSearch != "" ? this.idPrivateWeb : null
      );
      await TargetService.update(this.idTarget, formUpdate)
        .then((response) => {
        //   this.statusProcess = true;
        //   this.messageProcess = "Success saving all target information";
        //   setTimeout(() => {
        //     this.loadingProcess = false;
        //   }, 500);
        //   Vue.swal({
        //     position: "top-end",
        //     icon: "success",
        //     title: response.data.message,
        //     showConfirmButton: false,
        //     timer: 1500,
        //   });
        //   this.disableFinish = false;
        
          this.phoneinfo = [];
          this.$router.push("/project");
        })
        .catch((err) => {
        //   this.statusProcess = true;
        //   this.messageProcess = "Failed saving all target information";
        //   setTimeout(() => {
        //     this.loadingProcess = false;
        //   }, 500);
        //   this.disableFinish = false;
          console.log(err);
        });
    },
    /** ======================================*/
    //================================== wizard 4 ===================================//

    //================================== support ===================================//
    // getPreferences() {
    //   PreferenceService.getAllElastic()
    //     .then((response) => {
    //       this.elastic = response.data.data[0].ip_address;
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    updateTarget(data) {
      TargetService.update(this.idTarget, data)
        .then((response) => {})
        .catch((err) => {
          console.log(err);
        });
    },

    getCategory() {
      CategoryService.list()
        .then((response) => {
          this.category = response.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    
    formatDate(value) {
      return moment(value).format("YYYY-MM-DD");
    },

    normalizeUrl() {
      if (this.form.website != "") {
        try {
          let url = new URL(this.form.website);
          return url.host.replace("www.", "");
        } catch (error) {
          return this.form.website;
        }
      } else {
        return "";
      }
    },
    //================================== support ===================================//
  },
  beforeMount() {
    // this.getPreferences();
    // this.listProfile();
  },
  mounted() {
    this.getCategory();
  },
};
</script>

<style scoped>
.par {
  position: relative;
}

.cursor-pointer:hover {
  cursor: pointer;
}
.header-accordion-result:hover {
  cursor: pointer;
}
#tab-username {
  padding: 0;
}
</style>
